"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cutFields = void 0;
exports.default = addCutFnFields;
exports.getCutFnFields = getCutFnFields;
var _queryBuilderConfig = require("@kentik/ui-shared/dictionary/content/queryBuilderConfig");
const cutFields = exports.cutFields = ['c_dst_dns_query', 'c_src_dns_query', 'ktappprotocol__dns__STR00', 'ktappprotocol__dns__STR01', 'ktappprotocol__dhcp__STR01', 'ktappprotocol__dhcp__STR02', 'ktappprotocol__http__STR01', 'ktappprotocol__tls__STR00', 'ktappprotocol__http__STR00', 'ktappprotocol__http__STR02'];
function getCutFnFields() {
  const additionalCutFields = [];
  for (const [fieldName, {
    allowsCut
  }] of Object.entries(_queryBuilderConfig.queryBuilderConfig)) {
    if (allowsCut) {
      additionalCutFields.push(fieldName);
    }
  }
  return new Set([...cutFields, ...additionalCutFields]);
}
function addCutFnFields(dictionary) {
  return {
    ...dictionary,
    cutFn: {
      ...dictionary.cutFn,
      fields: [...getCutFnFields()]
    }
  };
}